import React from 'react';

import { Tooltip as AntDTooltip, TooltipProps } from 'antd';

const Tooltip = (props: TooltipProps) => {
  return (
    <AntDTooltip arrow={false} mouseEnterDelay={0.3} color={'#FFF'} overlayClassName="custom-tooltip" {...props} />
  );
};

export default Tooltip;
